export default "__VITE_ASSET__CXJkDWbW__"